<template>
<div>

</div>
</template>

<script>
export default {
  name: "MyBusinessInvistMoneyReport",
}
</script>

<style scoped>

</style>
